export enum ProcessLogStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    IN_PROGRESS = "IN_PROGRESS",
}

export interface ProcessLog{
    id: number;
    process: string;
    createdAt: string;
    updatedAt: string;
    status: ProcessLogStatus;
    body: string;
    restaurantShortName: string;
}